import React from "react";
import "./AboutUsMap.scss";

export default function AboutUsMap() {
  return (
    <div className="about-us-map">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2832.2068333903944!2d20.537305075762042!3d44.776588479054666!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475a774cc9f3b0cb%3A0x61bf543413dae2af!2sBulevar%20kralja%20Aleksandra%20642%2C%20Beograd!5e0!3m2!1sen!2srs!4v1752509898772!5m2!1sen!2srs"
        width="800"
        height="600"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}
